import React from 'react';
import { NavLink } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap';

import { accountURL, accountsURL } from '@admin/config/routes';
import { Admin__PaymentPlan__AccountFragment as PaymentPlanAccount } from '@admin/schema';

export const Breadcrumbs: React.FC<{
  account: PaymentPlanAccount;
  newPaymentPlan?: boolean;
}> = ({ account, newPaymentPlan = false }) => (
  <div className="text-overflow pad-top pad-btm page-header">
    <Breadcrumb>
      <Breadcrumb.Item>
        <NavLink to={accountsURL()}>Accounts</NavLink>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <NavLink to={accountURL(account)}>
          #{account.number} ({account.customer.name})
        </NavLink>
      </Breadcrumb.Item>
      <Breadcrumb.Item active>{newPaymentPlan && 'New'} Payment Plan </Breadcrumb.Item>
    </Breadcrumb>
  </div>
);
